
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetaxihire() {



  const cardData =
  {
    keyword: 'Pune Taxi Hire Service',
    heading: 'AB Ghule Cabs: Pune Taxi Hire Service',
    headingDescription: 'Explore Pune with ease and comfort through AB Ghule Cabs’ Pune Taxi Hire Service. Whether you need a ride for a business trip, sightseeing tour, family outing, or airport transfer, our fleet of well-maintained vehicles and professional drivers ensure a smooth and pleasant experience. We offer competitive pricing, reliability, and punctuality to meet your transportation needs in Pune.',

    top: 'Top Places to Visit in Pune with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Shaniwar Wada",
          description: "Shaniwar Wada is a historical fortification that once served as the seat of the Peshwas, the Maratha rulers. The impressive architecture and intricate carvings of this 18th-century fort provide a glimpse into Pune's royal past. Though much of the fort has been destroyed, it remains a significant landmark and a must-visit for history buffs and architecture enthusiasts. The site also hosts a sound and light show in the evening, making it an even more captivating experience."
        },
        {
          title: "Aga Khan Palace",
          description: "Aga Khan Palace is an elegant historical monument in Pune, built by Sultan Muhammad Shah Aga Khan in 1892. This palace is especially significant for its association with Mahatma Gandhi, who was imprisoned here during India's freedom struggle. The palace is surrounded by beautiful gardens, adding to the serene and peaceful atmosphere, making it a great place for reflection and learning about India’s independence movement."
        },
        {
          title: "Sinhagad Fort",
          description: "Sinhagad Fort, perched atop a hill, offers panoramic views of the surrounding hills and valleys. A popular destination for trekking, it combines adventure with history. The fort played a significant role in Maratha history and is famous for the Battle of Sinhagad in 1670. Whether you're an adventure lover, a history enthusiast, or simply someone who enjoys nature, Sinhagad Fort is a must-visit."
        },
        {
          title: "Pune Okayama Friendship Garden",
          description: "Inspired by Japanese landscaping, the Pune Okayama Friendship Garden is a tranquil oasis within the city. The lush greenery, serene ponds, and well-maintained walkways make it a perfect place for leisurely strolls, meditation, and picnics. The garden's peaceful environment provides a perfect escape from the hustle and bustle of Pune’s urban life."
        },
        {
          title: "Dagdusheth Halwai Ganapati Temple",
          description: "The Dagdusheth Halwai Ganapati Temple is one of Pune's most revered places of worship, dedicated to Lord Ganesha. Known for its exquisite architecture, the temple is a spiritual hub, especially during the Ganesh Chaturthi festival, when thousands of devotees flock to the temple. The temple's vibrant atmosphere and intricate artwork make it an iconic landmark in Pune."
        },
        {
          title: "Fergusson College",
          description: "Fergusson College is an iconic educational institution in Pune, known for its beautiful campus and rich history. Established in 1885, the college has been a prominent center for education. The lush green grounds and historical buildings offer a peaceful environment, perfect for a leisurely walk or photography. It's a great place to explore both history and nature in the heart of the city."
        },
        {
          title: "Pataleshwar Cave Temple",
          description: "The Pataleshwar Cave Temple is a rock-cut temple dedicated to Lord Shiva, offering a fascinating insight into ancient Indian architecture. Carved from solid rock, the temple's intricate carvings and serene ambiance transport visitors back in time. It's an excellent spot for history and architecture lovers, as well as anyone looking to experience Pune’s ancient cultural heritage."
        },
        {
          title: "Rajiv Gandhi Zoological Park",
          description: "The Rajiv Gandhi Zoological Park in Katraj is home to a variety of animals and birds, making it a great place for wildlife enthusiasts and families. The zoo also emphasizes conservation and education, with dedicated areas for different species. Visitors can enjoy walking through the lush green park, learning about wildlife, and observing animals in spacious, natural habitats."
        },
        {
          title: "Nehru Memorial Museum",
          description: "The Nehru Memorial Museum in Pune is dedicated to India's first Prime Minister, Jawaharlal Nehru. The museum showcases an extensive collection of photographs, letters, and artifacts that highlight Nehru’s contributions to India's independence and his role in shaping modern India. The museum offers a great educational experience for history enthusiasts and anyone interested in India's political history."
        },
        {
          title: "Mulshi Dam",
          description: "Mulshi Dam, located on the Mula River, is a scenic spot just outside Pune. The dam and its surrounding areas offer breathtaking views of the lush landscapes, especially during the monsoon season. It’s a popular place for picnics, photography, and nature walks. The tranquil atmosphere and beautiful surroundings make it an excellent destination for anyone looking to escape the city and enjoy nature."
        }
      ],


   services: [
    {
      "name": "Pune Airport Taxi Hire",
      description: "Looking for a reliable and comfortable airport taxi service in Pune? AB Ghule Cabs offers smooth airport transfers with well-maintained vehicles and professional drivers. Whether you're heading to or from Pune Airport, we ensure a safe, timely, and stress-free ride. Our taxi services are designed to meet your schedule, ensuring you reach your destination on time with maximum comfort."
    },
    {
      "name": "Pune Corporate Taxi Hire",
      description: "For business professionals in Pune, AB Ghule Cabs offers premium corporate taxi hire services. Whether it’s for a meeting, airport transfer, or office event, our executive taxis provide comfort, punctuality, and professionalism to meet your corporate needs. Our fleet of well-maintained vehicles ensures that you travel in style and arrive at your destination refreshed and on time."
    },
    {
      "name": "Luxury Taxi Hire Pune",
      description: "Travel in style with AB Ghule Cabs’ luxury taxi hire services in Pune. Our fleet includes high-end luxury vehicles equipped with top-notch amenities to make your ride memorable and comfortable. Whether it's a special occasion, VIP travel, or a luxury experience you're looking for, we offer the perfect solution with professional drivers ensuring a smooth and elegant journey."
    },
    {
      "name": "Pune Outstation Taxi Hire",
      description: "AB Ghule Cabs offers convenient and affordable outstation taxi hire services from Pune. Whether you're traveling to Shirdi, Mahabaleshwar, or any other destination, we provide well-maintained vehicles and professional drivers to ensure a smooth and comfortable journey. Our outstation services are designed for both relaxation and convenience, making long-distance travel a pleasure."
    },
    {
      "name": "Pune Local Taxi Rentals",
      description: "For exploring Pune and its nearby attractions, AB Ghule Cabs offers local taxi rentals. Whether you need a ride for a few hours or the entire day, our reliable taxis ensure you can travel comfortably within the city. We offer affordable prices and flexible rental options, giving you the freedom to explore Pune at your own pace, without any worries."
    },
    {
      "name": "Pune Wedding Taxi Service",
      description: "Make your wedding day extra special with AB Ghule Cabs’ wedding taxi services. We provide well-maintained vehicles and professional drivers for all your wedding transportation needs, including bridal cars, family transport, and guest transportation. Our fleet offers comfort and elegance to ensure your wedding day is memorable for all the right reasons."
    },
    {
      "name": "Pune Taxi Hire for Tours",
      description: "Book a taxi for your tour with AB Ghule Cabs. We provide taxi hire for both city tours and outstation trips, ensuring a comfortable and enjoyable journey to your desired destination. Whether you're exploring the local culture or heading to a distant landmark, our experienced drivers and well-maintained vehicles offer the perfect way to make your tour memorable."
    },
    {
      "name": "Economy Taxi Hire Pune",
      description: "Looking for an affordable taxi service in Pune? AB Ghule Cabs offers economy taxi hire services that fit your budget without compromising on quality. Perfect for short trips, daily commutes, or local sightseeing, our economy taxis ensure you get value for money, offering a comfortable and safe ride for any occasion."
    },
    {
      "name": "Pune Taxi Hire for Events",
      description: "Need a taxi for an event in Pune? AB Ghule Cabs offers reliable taxi hire services for events such as conferences, exhibitions, parties, and corporate functions. Book your ride with us to ensure you arrive at your event in style and comfort, with professional drivers who are dedicated to providing excellent service."
    },
    {
      "name": "Pune 24/7 Taxi Service",
      description: "AB Ghule Cabs offers 24/7 taxi service in Pune. Whether you need a ride at midnight or early morning, our round-the-clock service ensures you can rely on us for your travel needs, anytime. Our dependable drivers are available at any hour to provide you with a safe and efficient ride whenever you need it."
    },
    {
      "name": "Pune Taxi Hire",
      description: "For any taxi hire needs in Pune, AB Ghule Cabs is your go-to provider. We offer comfortable, punctual, and affordable taxi services throughout the city, ensuring a hassle-free travel experience. Whether you're commuting within the city or heading out for a longer journey, we guarantee timely arrivals and a smooth ride."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      description: "Travel from Pune to Mumbai Airport with AB Ghule Cabs for a reliable and timely service. Our taxi services provide a comfortable and smooth ride to the airport, ensuring you arrive well ahead of your flight. With our professional drivers and well-maintained vehicles, your travel experience will be stress-free and comfortable."
    },
    {
      "name": "AB Ghule Cabs",
      description: "AB Ghule Cabs offers a variety of taxi services in Pune and surrounding areas. Whether you need a local ride, an outstation trip, or airport transfer, our fleet of vehicles and professional drivers ensure you have a smooth and enjoyable journey. We prioritize customer satisfaction with reliable, safe, and timely services that make your travel easy and comfortable."
    },
    {
      "name": "Pune to Mumbai Cabs",
      description: "Book your Pune to Mumbai cab with AB Ghule Cabs for a convenient and affordable journey. Whether for business or leisure, we ensure a safe, comfortable, and smooth ride to your destination. Our experienced drivers and well-maintained vehicles guarantee an enjoyable travel experience, no matter the purpose of your trip."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab",
      description: "AB Ghule Cabs offers the cheapest taxi service for your journey from Pune to Mumbai. With affordable rates and high-quality service, we ensure you travel comfortably while staying within your budget. Our drivers are experienced and courteous, providing an excellent experience throughout the ride."
    },
    {
      "name": "Pune to Mumbai Cab Service",
      description: "Our Pune to Mumbai cab service is designed to provide convenience and comfort. Book a taxi with AB Ghule Cabs for a smooth ride with experienced drivers and well-maintained vehicles. Whether for business or leisure, we ensure you travel safely and reach your destination on time."
    },
    {
      "name": "Cab from Pune to Mahabaleshwar",
      description: "Travel to Mahabaleshwar with AB Ghule Cabs for a scenic and comfortable journey from Pune. Our cabs are equipped to provide a smooth ride to this beautiful hill station, known for its cool climate and lush landscapes. Whether it's for a short getaway or a long trip, our drivers ensure a stress-free journey to Mahabaleshwar."
    },
    {
      "name": "Taxi From Pune to Mahabaleshwar",
      description: "For a relaxing and comfortable taxi ride from Pune to Mahabaleshwar, book with AB Ghule Cabs. Our experienced drivers and well-maintained vehicles ensure a smooth and enjoyable journey, allowing you to appreciate the scenic beauty of the Western Ghats as you travel to this famous hill station."
    },
    {
      "name": "Book Cab in Pune",
      description: "Booking a cab in Pune has never been easier. With AB Ghule Cabs, you can book a taxi online or by phone for any destination within the city or for outstation trips. Our prompt service, affordable pricing, and professional drivers ensure a seamless experience every time you travel."
    },
    {
      "name": "Pune to Aurangabad Taxi",
      description: "Travel from Pune to Aurangabad comfortably with AB Ghule Cabs. Our taxi service offers a hassle-free and scenic ride to this historical city, which is famous for its heritage sites like the Ajanta and Ellora caves. Whether for business or leisure, our reliable drivers and well-maintained vehicles ensure an enjoyable journey."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      description: "Book your cab from Pune to Mumbai with AB Ghule Cabs for a smooth, comfortable, and affordable journey. Our reliable taxi services guarantee a safe and timely ride, ensuring you reach your destination without hassle. Choose us for a seamless booking experience and a pleasant travel experience."
    },
    {
      "name": "Pune Mumbai Cabs",
      description: "Choose AB Ghule Cabs for your Pune to Mumbai travel. Our fleet of vehicles offers comfort and affordability, ensuring you get the best value for your journey. Whether for a short trip or a longer stay, our professional drivers will ensure you have a safe and smooth ride."
    },
    {
      "name": "Outstation Car Rental Pune",
      description: "AB Ghule Cabs provides outstation car rental services from Pune to various destinations. Whether you're heading to Shirdi, Mahabaleshwar, or any other city, our fleet is well-equipped for a comfortable journey. We offer flexible rental options, ensuring a smooth and enjoyable travel experience."
    },
    {
      "name": "Pune to Mumbai Cab One Way",
      description: "For a one-way journey from Pune to Mumbai, AB Ghule Cabs offers competitive rates and reliable services. Travel hassle-free with our experienced drivers and well-maintained vehicles. We ensure that your one-way trip is timely, comfortable, and affordable."
    },
    {
      "name": "Pune Taxi Hire Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient taxi services in Pune. Whether you're booking a ride to Mumbai, Shirdi, or any local destination, our team ensures a smooth and enjoyable experience from start to finish."
    }
],



tableData: [
    ["-Pune Airport Taxi Hire", "-Convenient and reliable taxi hire services from Pune Airport"],
    ["-Pune Corporate Taxi Hire", "-Professional taxi hire for corporate travel in Pune"],
    ["-Luxury Taxi Hire Pune", "-Premium taxi hire options for a comfortable and luxurious ride in Pune"],
    ["-Pune Outstation Taxi Hire", "-Reliable outstation taxi services for trips from Pune"],
    ["-Pune Local Taxi Rentals", "-Affordable local taxi rentals for all your Pune travel needs"],
    ["-Pune Wedding Taxi Service", "-Specialized taxi services for weddings and events in Pune"],
    ["-Pune Taxi Hire for Tours", "-Comfortable and convenient taxi hire services for your Pune tour"],
    ["-Economy Taxi Hire Pune", "-Budget-friendly taxi hire options for affordable travel in Pune"],
    ["-Pune Taxi Hire for Events", "-Taxi hire services for events and special occasions in Pune"],
    ["-Pune 24/7 Taxi Service", "-Round-the-clock taxi services in Pune, available anytime you need"],
    ["-Pune Taxi Hire", "-Reliable and affordable taxi hire services for your Pune travels"],
    ["-Pune to Mumbai Airport Cab", "-Comfortable taxi services for your journey from Pune to Mumbai Airport"],
    ["-AB Ghule Cabs", "-Trusted taxi services provider for all your travel needs in Pune"],
    ["-Pune to Mumbai Cabs", "-Reliable and affordable cab service from Pune to Mumbai"],
    ["-Pune to Mumbai Cheapest Cab", "-Budget-friendly taxi service from Pune to Mumbai"],
    ["-Pune to Mumbai Cab Service", "-Comfortable and affordable taxi service from Pune to Mumbai"],
    ["-Cab from Pune to Mahabaleshwar", "-Reliable taxi services for a smooth ride from Pune to Mahabaleshwar"],
    ["-Taxi From Pune to Mahabaleshwar", "-Affordable taxi services for your journey from Pune to Mahabaleshwar"],
    ["-Book Cab in Pune", "-Easy and quick booking for your taxi ride in Pune"],
    ["-Pune to Aurangabad Taxi", "-Affordable and reliable taxi service from Pune to Aurangabad"],
    ["-Pune to Mumbai Cab Booking", "-Convenient booking for your Pune to Mumbai cab ride"],
    ["-Pune Mumbai Cabs", "-Comfortable and affordable cabs for your Pune to Mumbai journey"],
    ["-Outstation Car Rental Pune", "-Convenient car rental services for outstation trips from Pune"],
    ["-Pune to Mumbai Cab One Way", "-One-way taxi services for your journey from Pune to Mumbai"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "-Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we provide trustworthy and professional taxi hire services in Pune. Our team of drivers is highly skilled, courteous, and focused on offering you a safe, pleasant, and hassle-free ride."
    },
    {
      WhyChooseheading: "-24/7 Availability",
      WhyChoosedescription: "We understand that travel plans can change at any moment. That’s why we offer 24/7 taxi services to ensure you can rely on us for rides at any time, day or night. Whether it's for an urgent meeting or a late-night ride, we're ready to serve you."
    },
    {
      WhyChooseheading: "-Affordable and Transparent Pricing",
      WhyChoosedescription: "Our taxi hire services come with transparent, competitive pricing. Whether you're traveling for business, leisure, or any other purpose, our pricing is designed to fit every budget. No hidden charges, just clear and honest fare structures."
    },
    {
      WhyChooseheading: "-Clean and Well-Maintained Fleet",
      WhyChoosedescription: "Our fleet consists of clean, well-maintained taxis that are inspected regularly for safety and comfort. From budget-friendly options to premium cars, we offer a range of vehicles to suit your needs."
    },
    {
      WhyChooseheading: "-Experienced and Safe Drivers",
      WhyChoosedescription: "Your safety is our priority. All of our drivers are experienced, background-checked, and familiar with Pune’s roads and traffic conditions, ensuring a smooth and safe ride to your destination."
    },
    {
      WhyChooseheading: "-Easy and Quick Booking",
      WhyChoosedescription: "Booking your taxi is simple and hassle-free. You can book a ride via our website, mobile app, or by calling our customer service team for immediate assistance, available at any time."
    },
    {
      WhyChooseheading: "-Customer Satisfaction Guarantee",
      WhyChoosedescription: "We are dedicated to providing a seamless, pleasant experience for our customers. With a strong track record of positive reviews, we always ensure that your ride is comfortable, and we're ready to address any concerns or requests you might have."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I hire a taxi with AB Ghule Cabs in Pune?',
      answer: 'You can easily hire a taxi by visiting our website, using our mobile app, or by calling our customer service. We ensure an effortless booking process to suit your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'What types of taxis are available for hire in Pune?',
      answer: 'We offer a wide range of taxis, including economy sedans, SUVs, and premium cars. You can select a vehicle based on your preferences, budget, and the type of trip you’re planning.',
    },
    {
      id: 'FAQ3',
      question: 'How do I pay for my taxi ride?',
      answer: 'Payment can be made via cash, credit/debit cards, or online payment options through our mobile app, offering you flexibility and convenience.',
    },
    {
      id: 'FAQ4',
      question: 'Are the drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are highly trained, experienced, and background-checked to ensure your safety and comfort throughout the journey.',
    },
    {
      id: 'FAQ5',
      question: 'Do you offer airport pick-up and drop-off services in Pune?',
      answer: 'Yes, we offer reliable and punctual airport pick-up and drop-off services in Pune. Whether you’re catching a flight or arriving in the city, our drivers will ensure you reach your destination on time.',
    },
    {
      id: 'FAQ6',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, but our pricing is transparent, and you will be informed in advance about any extra costs before your ride begins.',
    },
    {
      id: 'FAQ7',
      question: 'Can I cancel or modify my taxi booking?',
      answer: 'Yes, you can easily cancel or modify your booking through our website or app. Our customer service team is available to assist with any changes you need to make.',
    },
    {
      id: 'FAQ8',
      question: 'Do you offer intercity taxi services from Pune?',
      answer: 'Yes, we offer intercity taxi services to nearby cities and destinations, making long-distance travel comfortable and affordable.',
    },
    {
      id: 'FAQ9',
      question: 'Is AB Ghule Cabs available for corporate travel in Pune?',
      answer: 'Yes, we provide corporate taxi hire services for businesses, including employee transportation, meetings, and events. We can customize packages based on your business needs.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs different from other taxi services in Pune?',
      answer: 'AB Ghule Cabs stands out because of our commitment to customer satisfaction, competitive pricing, safe and experienced drivers, well-maintained vehicles, and exceptional customer support. We offer a reliable and comfortable travel experience in Pune.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Karan Joshi",
      feedback: "I hired a taxi from AB Ghule Cabs for a business trip in Pune, and I was extremely pleased with the service. The driver was professional, the vehicle was clean and comfortable, and the ride was smooth. I highly recommend AB Ghule Cabs for anyone needing reliable taxi services in Pune!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Simran Kapoor",
      feedback: "I used AB Ghule Cabs for a day trip around Pune, and I had a great experience. The driver was on time, very friendly, and knowledgeable about the city. The taxi was well-maintained and made the journey very comfortable. I will definitely choose AB Ghule Cabs again for my future trips!",
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>

<Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune Taxi Hire | Taxi Hire Services in Pune</title>
  <meta name="description" content="Pune taxi hire services for airport transfers, corporate needs, outstation trips, weddings, and events. Affordable and luxury taxi options available 24/7. Book a taxi for Pune to Mumbai, Mahabaleshwar, Aurangabad, and more." />
  <meta name="keywords" content="Pune Airport Taxi Hire, Pune Corporate Taxi Hire, Luxury Taxi Hire Pune, Pune Outstation Taxi Hire, Pune Local Taxi Rentals, Pune Wedding Taxi Service, Pune Taxi Hire for Tours, Economy Taxi Hire Pune, Pune Taxi Hire for Events, Pune 24/7 Taxi Service, Pune Taxi Hire, Pune to Mumbai Airport Cab, AB Ghule Cabs, Pune to Mumbai Cabs, Pune to Mumbai Cheapest Cab, Pune to Mumbai Cab Service, Cab from Pune to Mahabaleshwar, Taxi From Pune to Mahabaleshwar, Book Cab in Pune, Pune to Aurangabad Taxi, Pune to Mumbai Cab Booking, Pune Mumbai Cabs, Outstation Car Rental Pune, Pune to Mumbai Cab One Way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune Taxi Hire | Taxi Hire Services in Pune" />
  <meta property="og:description" content="Pune taxi hire services for airport transfers, corporate needs, outstation trips, weddings, and events. Affordable and luxury taxi options available 24/7. Book a taxi for Pune to Mumbai, Mahabaleshwar, Aurangabad, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-taxi-hire.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-taxi-hire" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune Taxi Hire",
        description: "Pune taxi hire services for airport transfers, corporate needs, outstation trips, weddings, and events. Affordable and luxury taxi options available 24/7. Book a taxi for Pune to Mumbai, Mahabaleshwar, Aurangabad, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-taxi-hire",
        "logo": "https://abghulecabs.com/images/pune-taxi-hire.jpg",
        "image": "https://abghulecabs.com/images/pune-taxi-hire.jpg",
        "priceRange": "₹1000 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-taxi-hire",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "850"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha Patil"
            },
            "datePublished": "2024-12-15",
            "reviewBody": "Excellent taxi service in Pune! I hired a cab for an outstation trip to Mahabaleshwar, and it was a smooth and safe journey."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Amit Sharma"
            },
            "datePublished": "2024-11-25",
            "reviewBody": "Affordable and professional. The ride from Pune to Mumbai airport was on time and stress-free. Highly recommend their services!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-taxi-hire"
        },
        "keywords": "Pune Airport Taxi Hire, Pune Corporate Taxi Hire, Luxury Taxi Hire Pune, Pune Outstation Taxi Hire, Pune Local Taxi Rentals, Pune Wedding Taxi Service, Pune Taxi Hire for Tours, Economy Taxi Hire Pune, Pune Taxi Hire for Events, Pune 24/7 Taxi Service, Pune Taxi Hire, Pune to Mumbai Airport Cab, AB Ghule Cabs, Pune to Mumbai Cabs, Pune to Mumbai Cheapest Cab, Pune to Mumbai Cab Service, Cab from Pune to Mahabaleshwar, Taxi From Pune to Mahabaleshwar, Book Cab in Pune, Pune to Aurangabad Taxi, Pune to Mumbai Cab Booking, Pune Mumbai Cabs, Outstation Car Rental Pune, Pune to Mumbai Cab One Way"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/12.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetaxihire;